<template>
  <div
    class="body"
    style="background: radial-gradient(circle, rgba(45,46,47,1) 20%, rgba(111,142,148,1) 100%);padding:12% 35% 20% 35%;height: 100vh!important;"
  >
    <div class="vue-template">
      <form>
        <h3></h3>
        <div class="form-group">
          <label>{{ $t("Кодни киритинг") }}</label> {{min+':'}}<span v-if="sek<10">0</span>{{sek}}
          <input
            type="text"
            ref="focused"
            v-model="code"
            class="form-control form-control-lg"
          />
        </div>

        <button
          type="button"
          class="btn btn-dark btn-lg btn-block"
          @click="Send()"
        >
          {{ $t("Сақлаш") }}
        </button>
        <div class="end">
        <!-- <button type="button" @click="Repeat()">{{ $t("Қайта жўнатиш") }}</button> -->
        </div>
        <p class="forgot-password text-right mt-2 mb-4"></p>
      </form>
    </div>
  </div>
</template>
<style>
.vue-template form {
  padding: 2% 8%;
  border-radius: 10px;
  background: white;
}

.vs__selected-options {
  max-width: 100% !important;
}
</style>

<script>
export default {
  data() {
    return {
      time:180,
      min:0,
      sek:0,
      data: [],
      code:'',
    };
  },
  methods: {
    Focus() {
      this.$refs.focused.focus();
    },
    Timer() {
      let self=this;
      setInterval(() => {
        self.time=self.time-1;
          if(self.time>60){
            self.min=parseInt(self.time/60);
            self.sek=self.time-(self.min*60);
          }else if(self.time>0){
            self.min=0
            self.sek=self.time-1;
          }    
      }, 1000);
    },
    Repeat() {
      let self = this;
      const username = self.data.username;
      const password = self.data.password;
      const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
      axios
        .get(self.data.url+"/getLoadSms?secret_code="+self.$route.params.code,{
        headers: {
          'Authorization': `Basic ${token}`
        }})
        .then(function(response) {
          if(response.data.error==false){
            self.time=180;
          }else{
            self.$store.state.error=response.data.message;
          }
        });
    },
    Send() {
      let self = this;
      const username = self.data.username;
      const password = self.data.password;
      const token = Buffer.from(`${username}:${password}`, 'utf8').toString('base64')
      axios({
            method: "post",
            url: self.data.url+"/LoadConfirm",
            data: { secret_code: self.$route.params.code, sms_code: self.code,token:'',IpServer:'',IpPort:'',IpServerMobile:""},
            headers: {
              'Authorization': `Basic ${token}`
            }
            },
            ).then(function (response) {
              if(response.data.error==false){
                var port=":3001";
                if(response.data.data.ipport!=0){
                  port=":"+response.data.data.ipport;
                }
                localStorage.setItem("ip", "http://" + response.data.data.ipaddress + port);
                    axios.defaults.baseURL="http://" + response.data.data.ipaddress + port
                self.$router.push({ name: "Login" });
              }else{
                self.$store.state.errors=response.data.message;
              }
            });
    }
  },
  created(){
    this.Timer();
  },
  mounted() {
    let self=this;
    axios
        .get("https://bdm.uz/server/url")
        .then(function(response) {
          self.data = response.data;
        });
    self.Focus();
  }
};
</script>
